import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { Ripple } from "primereact/ripple";

import LogoBmbDe from "../../../../../assets/images/logo/bmb/company-logo-de.svg";
import LogoBmbEn from "../../../../../assets/images/logo/bmb/company-logo-en.svg";
import LogoBmbFr from "../../../../../assets/images/logo/bmb/company-logo-fr.svg";
import LogoBmwetDe from "../../../../../assets/images/logo/bmwet/company-logo-de.png";
import LogoBmwetEn from "../../../../../assets/images/logo/bmwet/company-logo-en.png";
import LogoBmwetFr from "../../../../../assets/images/logo/bmwet/company-logo-fr.png";
import LogoSmall from "../../../../../assets/images/logo/company-logo-small.png";
import { AppLanguageOptionsSubsetEnum } from "../../../../models/constants/app-language-options.const";
import { Device } from "../../../../stores";
import { useStore } from "../../../../stores/StoreContext";

import "./CompanyLogo.scss";

import { customerName } from "../../../../../environmentConfiguration";

const allCustomerLogos: Record<"bmwet" | "bmb", Record<AppLanguageOptionsSubsetEnum, string>> = {
  bmwet: {
    de: LogoBmwetDe,
    en: LogoBmwetEn,
    fr: LogoBmwetFr,
  },
  bmb: {
    de: LogoBmbDe,
    en: LogoBmbEn,
    fr: LogoBmbFr,
  },
};

const defaultCustomerName = "bmwet";
const defaultLanguageCode: AppLanguageOptionsSubsetEnum = "de";

const customerLogos = allCustomerLogos[customerName] ?? allCustomerLogos[defaultCustomerName];

const CompanyLogoRaw: FunctionComponent = () => {
  const { navigationStore, userStore, breakpointStore } = useStore();

  const getCurrentLogo = (languageCode: AppLanguageOptionsSubsetEnum): string => {
    return customerLogos[languageCode];
  };

  const [logo, setLogo] = useState<string>(getCurrentLogo(defaultLanguageCode));

  useEffect(() => {
    setLogo(getCurrentLogo(userStore.currentLanguage.code as AppLanguageOptionsSubsetEnum));
  }, [userStore.currentLanguage]);

  const logoMemo = useMemo(() => {
    if (breakpointStore.isSmallerThan(Device.Tablet)) {
      return <img src={LogoSmall} alt="Company Logo" className="small-logo" />;
    }

    return <img src={logo} alt="Company Logo" />;
  }, [logo, breakpointStore.device]);

  return (
    <Link target="_self" to={navigationStore.landingPage.url ?? "/"}>
      <div className="logo-container p-ripple">
        {logoMemo}

        <Ripple />
      </div>
    </Link>
  );
};

export const CompanyLogo = observer(CompanyLogoRaw);
